import { SEND_EMAIL } from './constants'

const initialState = {
  isFetching: false,
  success: false,
  error: ''
}

export default function mailerReducer(state = initialState, action) {
  switch (action.type) {
    case SEND_EMAIL.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case SEND_EMAIL.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        success: true
      }
    }

    case SEND_EMAIL.FAILURE: {
      return {
        ...state,
        isFetching: false,
        success: false,
        error: 'Invalid email'
      }
    }
    default: {
      return state
    }
  }
}
